module.exports = __webpack_public_path__ + "static/img/page top img_tape_mobile.48642003.jpg";